
import axios from '@/axios.js'

export default {

  fetchAset ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/aset-list', payload)
        .then((response) => {
          commit('SET_ASETS', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
    })
  },

  // TAG
    fetchTag ({ commit }, tag) {
      return new Promise((resolve, reject) => {
        axios.get(`/term-list/tag-${tag}`)
          .then((response) => {
            commit('SET_TAGS', response.data.data)
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },
    addTag ({ commit }, tag) {
      return new Promise((resolve, reject) => {
        axios.post('/term-add', tag)
          .then((response) => {
            commit('ADD_TAG', response.data.data)
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },
    setTag ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/set-tags', payload)
        .then((response) => {
          commit('UPDATE_TAGS', payload)
          resolve(response)
        })
        .catch((error) => { reject(error) })
      })
    },
  //

  // Akumulasi
    fetchAkumulasi ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`/akumulasi-list/${payload}`)
        .then((response) => {
          commit('SET_AKUMULASI', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    akumulasiAdd ({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.post('/akumulasi-add', data)
        .then((response) => {
          commit('ADD_AKUMULASI', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    akumulasiRemove ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/akumulasi-remove', payload)
        .then((response) => {
          commit('REMOVE_AKUMULASI', payload)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    fetchAkumulasiTrash ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.get(`/akumulasi-list-trash/${payload}`)
        .then((response) => {
          commit('SET_AKUMULASI', response.data.data)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },

    akumulasiRestore ({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('/akumulasi-restore', payload)
        .then((response) => {
          commit('RESTORE_AKUMULASI', payload)
          resolve(response.data)
        })
        .catch((error) => { reject(error) })
      })
    },
  //

}
